<template>
<div >
    <router-view v-slot="{ Component }" >
        <transition :name="transitionName">
            <div :key="key" style="height: 100%;">
                <component :is="Component" />
            </div>
        </transition>
    </router-view>
</div>
</template>

<script>
export default {
  name: "AppMain",
  computed: {
    key() {
      return this.$route.path;
    },
  },
  data: () => ({
    transitionName: "slide-left",
    footerTabs: ["home", "timeline", "like", "message", "profile"],
  }),
  watch: {
    $route(to, from) {
      const toDepth = to.path.split("/").length;
      const fromDepth = from.path.split("/").length;

      this.transitionName =
        toDepth < fromDepth ? "slide-left" : "slide-right";

      // Transition for Footer tabs
      if (
        this.footerTabs.includes(to.name) &&
        this.footerTabs.includes(from.name)
      ) {
        this.transitionName =
          this.footerTabs.indexOf(to.name) > this.footerTabs.indexOf(from.name)
            ? "slide-right"
            : "slide-left";
      }
     
    },
  },
};
</script>
<style>

.slide-left-enter-active,
.slide-left-leave-active,
.slide-right-enter-active,
.slide-right-leave-active {
  position: absolute !important;
  transition: all 0.2s ease !important;
  top: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  left: 0 !important;
  overflow: hidden !important;
}

.slide-left-enter-from {
  left: -100% !important;
}

.slide-right-enter-from {
  left: 100% !important;
}

.slide-left-enter-to,
.slide-right-enter-to {
  left: 0% !important;
}

.slide-left-leave-from {
  left: 0% !important;
}
.slide-right-leave-from {
  left: 0% !important;
}

.slide-left-leave-to {
  left: 100% !important;
}
.slide-right-leave-to {
  left: -100% !important;
}
</style>